import ImageAsmir from '../assets/img/AboutUs/asmir.jpg';
import ImageWorker from '../assets/img/AboutUs/worker.jpg';

const dataAboutUs = {
    workerImage: ImageWorker,
    ownerImage: ImageAsmir,
    text: 'Ich habe die Firma Stuck Veskovic im Jahr 2000 gegründet und konnte meine Leidenschaft zum Beruf machen. Seitdem begeistert meine Firma mit hervorragender Leistung und dem Auge fürs Detail meine Kunden.Meinen Meistertitel habe ich im Jahr 2007 in Belgrad gemacht, welcher international anerkannt ist. Nach mehrfachen Weiterbildungen ist er im Jahr 2012 in der Bundesrepublik Deutschland anerkannt worden.',
    text1: 'Wir setzen die Wünsche der Kunden um und legen noch eine Prise Erfahrung obendrauf.Egal ob kleine Projekte oder große Projekte, wir sind immer mit vollem Herzen dabei.',
    text2: 'Ob sehr schlicht oder ausgefallen, mit Stuck Veskovic sind Sie immer auf der richtigen Seite.Wir bringen das Urlaubserlebnis zu Ihnen nach Hause.',
    text3: 'Das Stuckhandwerk ist für uns die Möglichkeit, Ihren Räumen und Gebäuden, sowohl im Innenraum als auch im Außenbereich einen einzigartigen Charakter und ein unvergleichliches Ambiente zu verleihen.',
    text4: 'Wir beherrschen sowohl das traditionelle Handwerk mit moderner Technik, ausgesuchten Materialien, umfassender Erfahrung und enormer Leidenschaft.',
    text5: 'Wir freuen uns auf Sie!',
    owner: 'Asmir Vesković',
    title: 'Gründer',
    address: 'Eichmühle 1, 36251 BAD HERSFELD',
    longitude: 50.841970031518485,
    latitude: 9.679960020906403
}

export default dataAboutUs
